import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";
import { Helmet } from "react-helmet";

import { bookMarketingImg2, proofReadingImg2 } from "../../asserts/images";

const ProofReading = () => {
  return (
    <>

    <Helmet>
        <meta charSet="utf-8" />
        <title>
            Expert Book Proofreader Services | Falcon Book Writing
        </title>
        <meta
          name="description"
          content="Hire expert book proofreaders with Falcon Book Writing to polish your manuscript, correct errors, and ensure a professional, flawless, publication-ready book."
        />
        <meta name="keywords" content="Book Proofreader Services" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>


      <UserLayout>
        <InnerHero
          innerheroclass="proofReadingBg"
          title="Eliminate Errors and"
          subtitle=" Enhance Readability "
          title2=" Through Book Proofreading"
          para="Ensure your manuscript is flawless with professional book proofreading. Every typo, grammatical error, and formatting inconsistency is carefully corrected, enhancing clarity, readability, and flow, so your book presents a polished, professional, and engaging experience for readers."
        />

        <Section2
          innerSec2Class="innerbrilliant_mind_section"
          title="Polishing Every Word for a   "
          subtitle=" Flawless Reading Experience "
        //   subtitle1="How we work?"
          description="A great book deserves to be read without distraction. Our professional proofreading service meticulously reviews every word, sentence, and paragraph to ensure your manuscript is free from errors, inconsistencies, and formatting issues. We focus on grammar, punctuation, spelling, and style while maintaining your unique voice, making sure the story flows naturally and engages readers from start to finish. Every chapter is carefully examined to enhance readability, clarity, and overall impact, transforming your draft into a polished, professional work. Whether your book is fiction, non-fiction, or a specialized guide, precise proofreading ensures your message is delivered flawlessly. With attention to detail and a commitment to perfection, we help your manuscript achieve its full potential, leaving readers with an immersive and error-free reading experience."
          // subtitle1="How we work?"
          // subtitle2="    Tailored Collaborations?"
          // subtitle3="  Expert Guidance"
          image={proofReadingImg2}
          imgClass="proofReadingImg2"
          actions={true}
          btn1="Let’s Get Start"
          btn2="Call Us Now"
        />

        <CustomCategory className="category_section2" />
        <FirstCustomBanner />
        <PublishBook />
        <Testimonial />
        <SecondCustomBanner />
        <CustomPublication />
        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default ProofReading;
